import React, { useCallback, useEffect, useRef, useState } from "react";
import { EyeOff, Eye } from "@desenvolvimento-intuix/ui-icons";

import { IPassword } from "../../../interfaces/password";
import { IStatus } from "../../../interfaces/status";

import { useName } from "../../../hooks/useName";
import { useInformations } from "../../../hooks/useInformations";

import { Informations } from "../../../components/Informations";

import * as S from "./styles";

export const Password: React.FC<IPassword> = (props) => {
  const informationsRef = useRef(null);

  const { informations, onValidate, getInformationsClasses } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  const [show, setShow] = useState(false);

  const onToggle = () => {
    if (props.disabled) return;

    setShow(!show);
  };

  const getType = useCallback(() => {
    return !show ? "password" : "text";
  }, [show]);

  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValue(props.value as string);
  }, [props.value]);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name, value } = event.target;

    setValue(value);

    props.onChange && props.onChange(name, value, event);
  };

  const { name } = useName(props.name);

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  useEffect(() => {
    if (props.required && !value) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    setStatus("VALIDATED");
  }, [value, props.required]);

  return (
    <S.Container className="input-password-container">
      <S.Input
        className={`input-password ${getInformationsClasses()} ${
          props.disabled ? "disabled" : ""
        }`}
      >
        <input
          {...{
            name,
            value,
            onChange,
            type: getType() || "password",
            onBlur: onValidate,
            "data-input": "password",
            "data-status": status,
            placeholder: props.placeholder,
            disabled: props.disabled,
          }}
        />

        <S.EyeContainer
          {...{
            type: "button",
            onClick: onToggle,
            className: "password-visibility-toggle",
            disabled: props.disabled,
          }}
        >
          {!show ? <Eye fontSize={24} /> : <EyeOff fontSize={24} />}
        </S.EyeContainer>
      </S.Input>
      <Informations
        {...{ ref: informationsRef, ...informations }}
        name={name}
      />
    </S.Container>
  );
};
